///
/// EarthBrowser
///
/// Created by Matt Giger on 2/12/2025
/// Copyright (c) 2025 Geodata Labs
///

import { Database } from "@/earthbrowser/database/Database"
import type { AdminInfo } from "@shared-types/location-info"

const cBatchSize = 500

export class CountryAdminTable {
	public static async exec(sql: string, params?: unknown[]): Promise<void> {
		await Database.db.exec(sql, params)
	}

	public static async select(country_code: string): Promise<AdminInfo[]> {
		const statement = 'select * from country_admin where country_code = ?'
		const result = await Database.db.exec(statement, [country_code])
		return result as AdminInfo[]
	}

	public static async insert(admins: AdminInfo[]): Promise<void> {
		const statement = `INSERT INTO country_admin (country_code, admin_code, name) VALUES (?, ?, ?)
			ON CONFLICT(country_code, admin_code) DO UPDATE SET name = excluded.name`
		for(let i=0; i<admins.length; i+=cBatchSize) {
			const batch = admins.slice(i, i+cBatchSize)
			// Reference-data ingest: low priority so it yields to visible-layer reads (see LocationsTable.insert)
			await Database.db.bulkInsert(statement, batch.map(admin => [admin.country_code, admin.admin_code, admin.name]), "low")
		}
	}
	public static async create(db: Database): Promise<void> {
		await db.execMany([
			{ sql: 'create table if not exists country_admin (country_code text, admin_code text, name text, PRIMARY KEY (country_code, admin_code))' },
			{ sql: 'create index if not exists country_admin_country on country_admin (country_code)' },
		])
	}

	public static async getCount(): Promise<number> {
		const rows = await Database.db.exec(
			`select count(*) as count from country_admin`,
			[],
			"low"
		) as Array<{ count: number }>
		return Number(rows[0]?.count ?? 0)
	}

	public static async drop(): Promise<void> {
		await Database.db.exec('drop table if exists country_admin')
	}
}